import clsx from "clsx";
import React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { Price } from "web/react/emo/product-price/price";
import { Sticker } from "web/react/emo/sticker";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";
import { useInStockProductPageContext } from "web/react/pages/product/in-stock/in-stock-product-page//in-stock-product-page.context";
import { BuyButton } from "web/react/pages/product/in-stock/in-stock-product-page/buy-button";
import * as styles from "./fixed-buy-on-store-button.css";

export function FixedBuyOnStoreButton({ showButton, isBefore }): JSX.Element {
    const {
        isLoggedIn,
        activeProduct: { price },
        activeBuyOption: { buyOption: activeBuyOption, index },
    } = useInStockProductPageContext();

    const eventLabel = isBefore
        ? "buy-on-store-button-before-main-cta"
        : "buy-on-store-button-after-main-cta";

    return (
        <SwitchTransition mode="out-in">
            <CSSTransition
                classNames={{
                    appear: styles.enter,
                    appearActive: styles.enterActive,
                    enter: styles.enter,
                    enterActive: styles.enterActive,
                    exit: styles.exit,
                    exitActive: styles.exitActive,
                }}
                key={showButton ?? null}
                timeout={250}
            >
                {showButton ? (
                    <View
                        className={clsx(styles.stickyWrapper, {
                            [styles.loggedInStickyWrapper]: isLoggedIn,
                        })}
                        paddingX={"md"}
                        paddingY={"sm"}
                    >
                        <span>
                            <VStack spacing="xxs">
                                <Price {...price} size={"lg"} />
                                <Sticker name={"lowestPrice"} />
                            </VStack>
                        </span>
                        <span className={styles.stickyWrapperButton}>
                            <BuyButton
                                variant="affiliate"
                                action="buy"
                                buyOption={activeBuyOption}
                                buyOptionPosition={index}
                                analyticsFunctionEventLabel={eventLabel}
                            />
                        </span>
                    </View>
                ) : (
                    <></>
                )}
            </CSSTransition>
        </SwitchTransition>
    );
}
